/**
 * @fileoverview POST handler for the "/apps/connected_content_credential/create" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsConnectedContentCredentialCreateCacheKeys } from "./constants";
import type {
  PostAppsConnectedContentCredentialCreateProps,
  AppsConnectedContentCredentialCreateResult,
} from "./types";

export const postAppsConnectedContentCredentialCreate = reactQueryMutationAdapter(
  appsConnectedContentCredentialCreateCacheKeys,
  (props: PostAppsConnectedContentCredentialCreateProps): Promise<AppsConnectedContentCredentialCreateResult> => {
    return fetch(
      "/apps/connected_content_credential/create",
      "POST",
      props,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
